
import { useState } from "react";
import Buttons from "../../../../components/ui/button/Buttons";
import UpdatePasswordForm from "./UpdatePasswordForm";
import CenterModel from "../../../../components/ui/centerModel/CenterModel";

const PasswordModel = ( props ) =>
{
    const [ isModelOpen, setIsModelOpen ] = useState( false );
    const [ modelDetail, setModelDetail ] = useState( {
        value: 0,
        label: "",
        component: null,
    } );

    const resetPassword = () =>
    {
        setIsModelOpen( !isModelOpen )
    };
    const openCloseModal = () =>
    {
        setIsModelOpen( !isModelOpen );
    };

    return (
        <div className="col-12 d-flex justify-content-end mt-4">
            <div className="reset-password-button">
                { isModelOpen && (
                    <CenterModel
                        modelTitle={ modelDetail.label }
                        show={ "test" }
                        handleClose={ openCloseModal }
                        onUpload={ openCloseModal }
                    >
                        { modelDetail.component }
                        <UpdatePasswordForm />
                    </CenterModel>

                ) }
                <Buttons
                    buttonText="Reset Password"
                    buttonTypeClassName="success-btn"
                    onClick={ () => resetPassword() }
                />

            </div>
        </div>
    )
};

export default PasswordModel;
